import { Mui } from "@osu/react-ui";
import { SESSION_KINDS } from "../../../util/constants";
import { useGetAllSessionsQuery } from "../../../services/submissionPeriod/api";
import Paper from "../Paper";
import Form from "./Form";
import { Fragment } from "react/jsx-runtime";

const Loader = () => {
  return (
    <Fragment>
      <Mui.Box display="flex" aria-hidden>
        <Mui.Skeleton sx={{ mr: 2 }} width="19.25rem" height="5rem" />
        <Mui.Skeleton width="19.25rem" height="5rem" />
      </Mui.Box>
      <Mui.Skeleton aria-hidden width="18rem" height="4rem" />
      <Mui.Typography variant="srOnly">Loading data export options...</Mui.Typography>
    </Fragment>
  );
}

function Exports(props = {}) {
  const { isLoading, isSuccess } = useGetAllSessionsQuery({
    type: SESSION_KINDS.FGC,
  });

  const headingId = "export-form-heading";
  const descriptorId = "export-form-description";

  return (
    <Paper>
      <Mui.Typography id={headingId} sx={{ paddingBottom: 2 }} variant="h2">
        Data Exports
      </Mui.Typography>
      <Mui.Typography variant="body1" id={descriptorId}>
        This feature allows you to download all records that are associated to a
        selected session. By default, it will include all records that are not
        deleted. You can change the status filter to specify which statuses you
        would like to include.
      </Mui.Typography>
      {isLoading && <Loader />}
      {isSuccess && (
        <Form
          aria-labelledby={headingId}
          aria-describedby={descriptorId}
        />
      )}
    </Paper>
  );
}

export default Exports;
